import { usePlane } from "@react-three/cannon";
import { useThree } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import * as THREE from "three";
// import { PalneType } from "types/three";




export const Plane = ({ scale = [10, 10, 0], position = [0, 0, 0], activeHelper = true, ...props }: PalneType) => {


    const helperRef = useRef<any>(null);

    const [ref] = usePlane<THREE.Mesh>(() => ({
        rotation: [-Math.PI / 2, 0, 0],
        receiveShadow: true,
        position: position,
        type: "Static", 
    }))





    const loadTuxtur = async () => {


        if (props.mapImgPath) {


            const texture = new THREE.TextureLoader().load(props.mapImgPath);



            texture.wrapS = THREE.RepeatWrapping; // Horizontal repeat
            texture.wrapT = THREE.RepeatWrapping; // Vertical repeat
            texture.repeat.set(1, 1);

            if (ref.current?.material) {

                if (Array.isArray(ref.current.material)) {
                    ref.current.material.forEach((mat) => {
                        // Cast material to  MeshPhysicalMaterial
                        const material = mat as THREE.MeshPhysicalMaterial;
                        if (material.map !== undefined) {

                            material.map = texture;
                            material.needsUpdate = true;
                        }
                    });
                } else {
                    // Single material case
                    const material = ref.current.material as THREE.MeshPhysicalMaterial;
                    if (material.map !== undefined) {
                        material.map = texture;
                        material.needsUpdate = true;
                    }
                }

            }



        }
    }

    useEffect(() => {
        loadTuxtur();
    }, [props.mapImgPath]);



    return (<mesh position={position}>
        {props.showHelper && <InteractionHandler activeHelper={activeHelper} helper={helperRef} helperMesh={props.helperMesh} onDoubleClick={(value) => props.onDoubleClick?.(value)} />}
        {props.showHelper && <primitive ref={helperRef} object={new THREE.GridHelper(scale[0], scale[1])} />}
        <mesh receiveShadow ref={ref}>
            <planeGeometry args={[scale[0], scale[1]]} />
            <meshPhysicalMaterial color={props.material?.color} clipShadows={true} shadowSide={THREE.DoubleSide} side={THREE.DoubleSide} />
        </mesh>
    </mesh>)
}



const InteractionHandler = ({ helper, onDoubleClick, helperMesh, activeHelper }: { activeHelper: boolean, helper: React.RefObject<any>, onDoubleClick: (position: THREE.Vector3) => void, helperMesh?: THREE.Mesh | null }) => {


    const { camera } = useThree();

    // the helper point
    let PlanHelper = null;

    if (activeHelper) {
        PlanHelper = helperMesh;
        let PlanHelperA = new THREE.Mesh(new THREE.PlaneGeometry(1, 1, 1), new THREE.MeshBasicMaterial({ color: "#f00", side: THREE.DoubleSide }));
        PlanHelperA.rotation.set(Math.PI / 2, 0, 0);
        PlanHelperA.updateMatrix();

        if (PlanHelper) {
            PlanHelper.add(PlanHelperA)
        } else {
            PlanHelper = PlanHelperA;
        }
    }

    const Plan = PlanHelper;




    useEffect(() => {
        const raycaster = new THREE.Raycaster();
        const pointer = new THREE.Vector2();

        Plan && helper.current && helper.current.add(Plan);

        const handleMove = (event: MouseEvent) => {
            pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
            pointer.y = -((event.clientY / window.innerHeight) * 2 - 1);

            // Set up the raycaster to check from the camera and through the pointer
            raycaster.setFromCamera(pointer, camera);

            // Intersect the helper (grid) to get the intersection point
            const intersects = raycaster.intersectObject(helper.current, true);

            if (intersects.length > 0) {

                // Get the intersection point in world coordinates
                const intersectionPoint = intersects[0].point;
                const snappedX = Math.round(intersectionPoint.x);
                const snappedZ = Math.round(intersectionPoint.z);

                if (Plan) {
                    Plan.position.set(snappedX, 0.1, snappedZ);
                    Plan.updateMatrix();
                }

            }
        }


        const handleClick = (event: MouseEvent) => {
            // Convert screen coordinates to normalized device coordinates
            pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
            pointer.y = -((event.clientY / window.innerHeight) * 2 - 1);

            // Set up the raycaster to check from the camera and through the pointer
            raycaster.setFromCamera(pointer, camera);

            // Intersect the helper (grid) to get the intersection point
            const intersects = raycaster.intersectObject(helper.current, true);

            if (intersects.length > 0) {

                // Get the intersection point in world coordinates
                const intersectionPoint = intersects[0].point;
                const snappedX = Math.round(intersectionPoint.x);
                const snappedZ = Math.round(intersectionPoint.z);

                // Create a new position vector with y = 0.5 to place the box slightly above the plane
                const centeredPosition = new THREE.Vector3(snappedX, 0, snappedZ);

                // Add a box at the intersection point
                onDoubleClick(centeredPosition);
            }
        };




        // const touch=()=>handleClick
        // Add event listener
        window.addEventListener("dblclick", handleClick);
        // window.addEventListener("ontouchstart",touch);
        window.addEventListener("mousemove", handleMove)

        return () => {
            window.removeEventListener("dblclick", handleClick);
            // window.removeEventListener("ontouchstart",touch);
            window.removeEventListener("mousemove", handleMove)
        };
    }, [helper, camera, onDoubleClick]);

    return null;
};